import { getConverter } from 'lib/firestore'
import {
  StoreDefaultBreadType,
  StoreDefaultDeliveryBreadType,
  StoreDefaultScheduleType,
  StoreDefaultType,
} from 'types/storeDefault'
import { FirebaseDocRefType } from 'firebase/index'

const storeDefaultConverter = getConverter<StoreDefaultType>()
const storeDefaultBreadConverter = getConverter<StoreDefaultBreadType>()
const storeDefaultScheduleConverter = getConverter<StoreDefaultScheduleType>()
const storeDefaultDeliveryBreadConverter = getConverter<StoreDefaultDeliveryBreadType>()

export const fetchStoreDefault = async (storeRef: FirebaseDocRefType) => {
  return storeRef
    .collection('store_defaults')
    .withConverter(storeDefaultConverter)
    .where('is_primary', '==', true)
    .get()
    .then((snapshots) => {
      const snapshot = snapshots.docs[0]
      if (!snapshot) return undefined
      return {
        ...snapshot.data(),
        ref: snapshot.ref,
      }
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchStoreDefaultBread = async (
  storeDefaultRef: FirebaseDocRefType
): Promise<StoreDefaultBreadType | undefined> => {
  return storeDefaultRef
    .collection('store_default_breads')
    .withConverter(storeDefaultBreadConverter)
    .get()
    .then((snapshots) => {
      const snapshot = snapshots.docs[0]
      if (!snapshot) return undefined
      return snapshot.data()
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchStoreDefaultSchedules = async (
  storeDefaultRef: FirebaseDocRefType
): Promise<StoreDefaultScheduleType[]> => {
  return storeDefaultRef
    .collection('store_default_schedules')
    .withConverter(storeDefaultScheduleConverter)
    .get()
    .then((snapshots) =>
      snapshots.docs.map((snapshot) => {
        return {
          ...snapshot.data(),
          schedule_ref: snapshot.ref,
        }
      })
    )
    .catch((error) => {
      console.error(error)
      return []
    })
}

export const fetchStoreDefaultDeliveryBread = async (
  storeDefaultRef: FirebaseDocRefType
): Promise<StoreDefaultDeliveryBreadType | undefined> => {
  return storeDefaultRef
    .collection('store_default_delivery_breads')
    .withConverter(storeDefaultDeliveryBreadConverter)
    .get()
    .then((snapshots) => {
      const snapshot = snapshots.docs[0]
      if (!snapshot) return undefined
      return {
        ...snapshot.data(),
        ref: snapshot.ref,
      }
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}
